import axios, { AxiosResponse } from 'axios'
import { IbgeCityDto } from 'src/dto/ibge.dto'

const IBGE_API = axios.create({
  baseURL: 'https://servicodados.ibge.gov.br/api/v1'
})

export class IbgeService {
  public async getCitiesByUf(uf: string): Promise<AxiosResponse<IbgeCityDto[]>> {
    return await IBGE_API.get(`/localidades/estados/${uf}/municipios?orderBy=nome`)
  }
}
